import { Grid, Typography, Box } from "@mui/material";

const renderIcono = (Icono) => {
    if (!Icono) return null;
    if (typeof Icono === "string") {
        return (
            <Box
                component="img"
                src={Icono}
                alt=""
                sx={{ width: 56, height: 56, objectFit: "contain" }}
            />
        );
    }
    const IconoComponente = Icono;
    return <IconoComponente sx={{ fontSize: 56, color: "#1C2B33" }} />;
};

const TAMANO_CIRCULO = 88;

const Tarjeta_Paso = ({
                          numero = "",
                          titulo = "Paso",
                          descripcion = "",
                          icono = null,
                      }) => {
    return (
        <Grid
            container
            direction="column"
            justifyContent="center"
            alignItems="center"
            size={{ xs: 12 }}
            spacing={1.2}
            sx={{ width: "100%", minWidth: 0 }}
        >
            <Grid
                container
                justifyContent="center"
                alignItems="center"
                sx={{ height: TAMANO_CIRCULO, mb: 1 }}
            >
                {renderIcono(icono)}
            </Grid>

            <Typography
                component="h3"
                variant="h5"
                sx={{ color: "#1C2B33", textAlign: "center" }}
            >
                {numero ? `${numero}. ${titulo}` : titulo}
            </Typography>

            <Typography
                component="p"
                variant="body1"
                sx={{
                    color: "#1C2B33",
                    textAlign: "center",
                    maxWidth: { xs: 260, md: "100%" },
                    width: "100%",
                }}
            >
                {descripcion}
            </Typography>
        </Grid>
    );
};

export { TAMANO_CIRCULO };
export default Tarjeta_Paso;